module.exports = __webpack_public_path__ + "static/img/6.e0633a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/6.png
// module id = LN69
// module chunks = 0